export const Settings = {
    debug: false
}